import "./style.scss";

export function single_text_block() {
  const blocks = document.querySelectorAll(".single_text_block");
  if (!blocks.length) return;
}
